import FirstLocationRedirect from "@/components/FirstLocationRedirect.tsx";

export default function WorkspaceId() {
  return <FirstLocationRedirect />;
}
